// extracted by mini-css-extract-plugin
export default {"container":"ActivityItem_container__+WQxW","openActivityIcon":"ActivityItem_openActivityIcon__Y6zAB","date":"ActivityItem_date__nm3+C"};